// File: src/components/FeaturedPuppies.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/FeaturedPuppies.css';

interface Puppy {
  id: number;
  name: string;
  breed: string;
  image: string;
  discount: string;
  newPrice: string;
  oldPrice: string;
  age: string;
  daysLeft: number;
}

const puppies: Puppy[] = [
  {
    id: 1,
    name: 'Alex',
    breed: 'Golden Retriever',
    image: require('../resources/gab1.png'),
    discount: '60% OFF',
    oldPrice: '$4,000',
    newPrice: '$1,300',
    age: '12 weeks old',
    daysLeft: 3,
  },
  {
    id: 2,
    name: 'Luna',
    breed: 'Labrador Retriever',
    image: require('../resources/set2.jpg'),
    discount: '55% OFF',
    oldPrice: '$5,500',
    newPrice: '$2,475',
    age: '10 weeks old',
    daysLeft: 5,
  },
  {
    id: 3,
    name: 'Bella',
    breed: 'French Bulldog',
    image: require('../resources/Mae2.png'),
    discount: '50% OFF',
    oldPrice: '$4,700',
    newPrice: '$2,350',
    age: '8 weeks old',
    daysLeft: 2,
  },
  {
    id: 4,
    name: 'Sprinkles',
    breed: 'Beagle',
    image: require('../resources/gab2.jpeg'),
    discount: '60% OFF',
    oldPrice: '$5,850',
    newPrice: '$2,340',
    age: '11 weeks old',
    daysLeft: 4,
  },
   {
    id: 5,
    name: 'Sunny',
    breed: 'Golden Retriever',
    image: require('../resources/set4.jpg'),
    discount: '51% OFF',
    oldPrice: '$4,200',
    newPrice: '$2,050',
    age: '9 weeks old',
    daysLeft: 4,
  },
  {
    id: 6,
    name: 'Daisy',
    breed: 'Labrador Retriever',
    image: require('../resources/Baguette3.png'),
    discount: '58% OFF',
    oldPrice: '$5,500',
    newPrice: '$2,310',
    age: '13 weeks old',
    daysLeft: 6,
  },
  {
    id: 7,
    name: 'Milo',
    breed: 'French Bulldog',
    image: require('../resources/set7.jpg'),
    discount: '50% OFF',
    oldPrice: '$4,000',
    newPrice: '$2,000',
    age: '11 weeks old',
    daysLeft: 3,
  },
  {
    id: 8,
    name: 'Max',
    breed: 'Beagle',
    image: require('../resources/set6.jpeg'),
    discount: '60% OFF',
    oldPrice: '$4,500',
    newPrice: '$2,700',
    age: '12 weeks old',
    daysLeft: 5,
  },
];

const FeaturedPuppies: React.FC = () => (
  <section className="featured-puppies">
    <div className="puppy-container">
      <div className="section-header">
        <h2 className="section-title">Flash Adoption Sale</h2>
        <div className="section-subtitle">
          Limited-time discounts on these adorable companions - Act fast before they find forever homes!
        </div>
      </div>

      <div className="puppy-grid">
        {puppies.map((puppy) => (
          <Link 
            to={`pets/${puppy.id}`} 
            className="puppy-card-link" 
            key={puppy.id}
          >
            <div className="puppy-card">
              <div className="image-container">
                <div className="discount-badge">
                  <div className="discount-text">{puppy.discount}</div>
                  <div className="discount-label">SAVINGS</div>
                </div>
                <img src={puppy.image} alt={puppy.breed} className="puppy-image" />
                <div className="countdown-timer">
                  <div className="countdown-label">SALE ENDS IN</div>
                  <div className="countdown-value">
                    <span className="days-left">{puppy.daysLeft}</span>
                    <span className="days-text"> DAYS</span>
                  </div>
                </div>
              </div>
              <div className="puppy-info">
                <div className="name-breed">
                  <h3 className="puppy-name">{puppy.name}</h3>
                  <p className="puppy-breed">{puppy.breed}</p>
                </div>
                
                <div className="price-container">
                  <div className="price-section">
                    <span className="old-price">{puppy.oldPrice}</span>
                    <span className="new-price">{puppy.newPrice}</span>
                  </div>
                  <div className="savings-text">
                    {`You save $${(
                      parseInt(puppy.oldPrice.replace(/[^0-9]/g, ''), 10) -
                      parseInt(puppy.newPrice.replace(/[^0-9]/g, ''), 10)
                    ).toLocaleString()}`}
                  </div>
                </div>
                
                <div className="puppy-meta">
                  <div className="puppy-age">{puppy.age}</div>
                  <div className="availability">Only 1 left!</div>
                </div>
                
                <div className="puppy-details">
                  <div className="view-detail-btn">Adopt Now</div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="sale-notice">
        <div className="sale-icon">⏱️</div>
        <div className="sale-text">Flash sale ends in 5 days! All discounts are final.</div>
      </div>
      
      <div className="view-all-container">
        <Link to="/pages/pets" className="view-all-btn">
          View All Pets
        </Link>
      </div>
    </div>
  </section>
);

export default FeaturedPuppies;